import Vue from 'vue'
import VTooltip, { VTooltip as TooltipDirective } from 'v-tooltip'

Vue.use(VTooltip, {
  popover: {
    defaultWrapperClass: 'vistat-tooltip-wrapper',
    defaultPlacement: 'top'
  }
})
Vue.directive('tooltip', TooltipDirective)
